import Layout from '../components/layout'
import Meta from '../components/meta'
import tw, { styled, css } from 'twin.macro'
import { navigate } from 'gatsby'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import '../components/fonts/flexo.css'


const RoundedContainer = styled.div`
	border-radius: 40px;
	overflow: hidden;
`

const compareTableRowData = [
    {
        title: 'Maximum Pool Length',
        items: ['Up to 15 metres', 'Up to 15 metres'],
    },
    {
        title: 'Cleaning Coverage',
        items: [
            'Floor, walls, waterline, sun ledges & steps (min 20 cm depth)',
            'Floor, walls, waterline, sun ledges & steps (min 20 cm depth)',
        ],
    },
    {
        title: 'Cleaning Cycle Time',
        items: ['1.5 / 2 / 2.5 hours', '1.5 / 2 / 2.5 hours'],
    },
    {
        title: 'App Connectivity',
        items: ['Maytronics One™ app', 'Maytronics One™ app'],
    },
    {
        title: 'Filter',
        items: ['Monoblock Filtration', 'DebrisLock™ Filtration'],
    },
    {
        title: 'Warranty',
        items: ['2 years', '3 years'],
    }
]

const CompareTableRow = ({ title, items }) => {
    return (
        <tr css={[tw`text-xs divide-x divide-white`]}>
            <td css={[tw`bg-blue-500 text-white font-bold py-2`]}> {title} </td>
            {items.map((item, i) => {
                return (
                    <td key={i} css={[tw`bg-gray-200 py-2`]}>
                        {' '}
                        {item}{' '}
                    </td>
                )
            })}
        </tr>
    )
}

const EonCordlessPoolCleaner = props => {
    // The state for the overlay is no longer needed since it's being replaced.
    // const [registerOverlay, setRegisterOverlay] = useState(false)
    const {
        EonHeroBannerImage,
        WhyChooseDolphinEON,
        EON120dLogo,
        Eon120dProductTile,
        Eon100ProductTile,
        Eon100Logo,
        Eon120TableImage,
        Eon100TableImage,
        EonGalleryIso1,
        EonGalleryIso2,
        EonGalleryIso3,
        EonFeatureTile1,
        EonFeatureTile2,
        EonFeatureTile3,
        EonFeatureTile4,
        DolphinEonLogoTagline,
        EonBannerTxt
    } = props.data

    const features = [
        {
            img: EonFeatureTile1,
            title: "Complete Pool Coverage",
            description: "Cleans floors, walls, steps and tanning ledges as shallow as 20 cm.",
        },
        {
            img: EonFeatureTile2,
            title: "JetIQ™ Step Cleaning",
            description: "Designed to maintain stability on steps for consistent, thorough cleaning.",
        },
        {
            img: EonFeatureTile3,
            title: "DebrisLock™ Filtration",
            description: "Patented backwash filtration captures ultra-fine debris for 4x clearer water (Eon 120d).",
        },
        {
            img: EonFeatureTile4,
            title: "App Controlled Simplicity",
            description: "Schedule cleanings, monitor status and troubleshoot seamlessly from your pool when the robot is out of the pool.",
        },
    ];

    return (
        <div>
            <Layout>
                <Meta
                    title="Dolphin EON Cordless Pool Cleaners"
                    keywords={[
                        'pool cleaner',
                        'robotic pool cleaner',
                        'cordless pool cleaner',
                        'pool vacuum'
                    ]}
                    description="Enjoy hassle free pool cleaning with EON. It requires fewer filter cleans than many other robotic pool cleaners and reaches areas other cleaners miss, including stairs, corners and shallow ledges."
                />

                {/* Tracking Script */}
                <script
                    type="application/javascript"
                    dangerouslySetInnerHTML={{
                        __html: `(function(w,d,t,r,u){w[u]=w[u]||[];w[u].push({'projectId':'10000','properties':{'pixelId':'10206112','he': '<email_address>','hph': '<phone_number>'}});var s=d.createElement(t);s.src=r;s.async=true;s.onload=s.onreadystatechange=function(){var y,rs=this.readyState,c=w[u];if(rs&&rs!="complete"&&rs!="loaded"){return}try{y=YAHOO.ywa.I13N.fireBeacon;w[u]=[];w[u].push=function(p){y([p])};y(c)}catch(e){}};var scr=d.getElementsByTagName(t)[0],par=scr.parentNode;par.insertBefore(s,scr)})(window,document,"script","https://s.yimg.com/wi/ytc.js","dotq");`,
                    }}
                />

                {/* Hero Image Section */}
                <div css={[tw`relative w-full overflow-hidden`, { height: '65vh' }]}>
                    <Img
                        fluid={EonHeroBannerImage.nodes[0].fluid}
                        alt={EonHeroBannerImage.nodes[0].alt || EonHeroBannerImage.nodes[0].title}
                        css={[
                            tw`w-full h-full`,
                            css`
                                img {
                                    object-fit: cover !important;
                                }
                            `,
                        ]}
                    />

                    {/* Left Side - Text Image + Buttons (vertically centered) */}
                    <div css={[
                        tw`absolute inset-y-0 left-6 md:left-28 lg:left-40 flex flex-col justify-center items-start gap-1`
                    ]}>
                        <Img
                            {...EonBannerTxt.nodes[0]}
                            loading="lazy"
                            css={[tw`w-[22rem] sm:w-72 md:w-[28rem] lg:w-[38rem]`]}
                        />
                        <div css={[tw`flex gap-3`]}>
                            <button
                                css={[
                                    tw`px-6 py-4 bg-transparent text-white font-bold rounded-full border border-white hover:bg-white hover:text-black transition-colors duration-200 shadow-lg whitespace-nowrap text-lg`,
                                ]}
                                onClick={() => navigate('/en-ZA/dolphin/eon-line')}
                            >
                                Buy Now
                            </button>
                            <button
                                css={[
                                    tw`px-6 py-4 bg-transparent text-white font-bold rounded-full border border-white hover:bg-white hover:text-black transition-colors duration-200 shadow-lg whitespace-nowrap text-lg`,
                                ]}
                                onClick={() => navigate('/en-ZA/book-a-demo/')}
                            >
                                Book a Demo
                            </button>
                        </div>
                    </div>
                </div>

                {/* Why choose Dolphin EON section*/}
                <div
                    css={[
                        tw`text-center px-4 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    <h1 css={[tw`font-black text-xl text-black md:text-2xl lg:text-3xl`]}>
                        <span css={[tw`ml-2 md:ml-4 lg:ml-6`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                            The Pool Cleaner That Reaches Where Others Can&apos;t.
                        </span>
                    </h1>
                    <p
                        css={[
                            tw`mt-3 mx-auto px-4 md:px-32 text-center text-sm md:text-base`,
                            { fontFamily: 'Flexo, system-ui, sans-serif !important' }
                        ]}
                    >
                        {' '}
                        The <span css={[tw`font-bold`]}>Dolphin EON</span> delivers powerful, intelligent cordless cleaning for pools up to 15 metres.
                        Designed for complete, consistent coverage, it cleans floors, walls, waterline, steps and
                        tanning ledges as low as 20 cm - leaving no area untouched.
                        <br />
                        <br />
                        Featuring SmartMap™ tailored navigation, extended runtime and app control via the
                        Maytronics One™ app, it ensures effortless operation and a thorough clean every time. The
                        <span css={[tw`font-bold`]}> EON 120d </span> enhances performance with up to 2.5 weeks of scheduled cleaning on a single
                        charge, along with patented DebrisLock™ backwash filtration for reduced maintenance.
                        <br />
                        <br />
                        The latest in cordless pool cleaning technology, the <span css={[tw`font-bold`]}>EON</span> adapts to your pool and keeps it
                        effortlessly clean all season long.
                    </p>

                    {/* Image section */}
                    <div css={[tw`text-center mt-6`]}>
                        <Img
                            {...WhyChooseDolphinEON.nodes[0]}
                            loading="lazy"
                            css={[
                                tw`w-full mx-auto rounded-3xl`,
                            ]}
                        />
                    </div>

                    {/*The Future of Pool Care*/}
                    <section css={[tw`px-4 pt-8 md:pt-12 lg:pt-16 mx-auto max-w-screen-lg w-full text-center`]}>
                        <h1 css={[tw`font-black text-xl text-black md:text-2xl lg:text-3xl`]}>
                            <span css={[tw`ml-2 md:ml-4 lg:ml-6`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                                The Future of Pool Care
                            </span>
                        </h1>

                        <div css={[tw`grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-8`]}>
                            {features.map((feature, index) => (
                                <div key={index} css={[tw`flex flex-col items-center text-center`]}>
                                    <div css={[tw`w-full mb-4`, css`aspect-ratio: 4 / 3;`]}>
                                        <Img
                                            {...feature.img.nodes[0]}
                                            loading="lazy"
                                            css={[
                                                tw`w-full h-full mx-auto rounded-2xl`,
                                                css`
                                                    img {
                                                        object-fit: cover !important;
                                                        object-position: center center !important;
                                                    }
                                                `,
                                            ]}
                                        />
                                    </div>

                                    <h3 css={[tw`text-base md:text-lg text-black font-black mb-2`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                                        {feature.title}
                                    </h3>

                                    <p css={[tw`text-sm md:text-base leading-snug`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                                        {feature.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </section>

                </div>

                {/* Meet the EON Range section */}
                <div
                    css={[
                        tw`text-center px-4 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    <h1 css={[tw`font-black text-xl text-black md:text-2xl lg:text-3xl`]}>
                        <span css={[tw`ml-2 md:ml-4 lg:ml-6`, { fontFamily: 'Flexo, system-ui, sans-serif !important' }]}>
                            Meet the Dolphin EON™ Range
                        </span>
                    </h1>

                    {/* Grid Container - 2 columns, 3 rows */}
                    <div
                        css={[
                            tw`grid md:grid-cols-2 gap-x-4 gap-y-10 md:gap-x-6 md:gap-y-14 lg:gap-x-8 lg:gap-y-16 mt-8 max-w-6xl mx-auto`,
                        ]}
                    >
                        {/* Grid Item 1 - EON 120d Content */}
                        <div
                            css={[
                                tw`bg-white rounded-lg items-start text-center md:text-left `,
                            ]}
                        >
                            <div css={[tw`rounded-2xl overflow-hidden mb-6`]}>
                                <Img
                                    {...EON120dLogo.nodes[0]}
                                    loading="lazy"
                                    css={[tw`w-56 md:w-64 lg:w-80 mx-auto md:mx-0`]}
                                />
                            </div>

                            <p
                                css={[
                                    tw`text-base md:text-lg lg:text-xl md:italic font-bold  mb-3 text-[#58c7de]`,
                                    { fontFamily: 'Flexo, system-ui, sans-serif !important' }
                                ]}
                            >
                                Best for full-featured performance
                            </p>

                            <ul
                                css={[
                                    tw`list-disc list-outside text-sm md:text-base lg:text-lg text-gray-700 text-left space-y-2 mx-auto md:mx-0`,
                                    { fontFamily: 'Flexo, system-ui, sans-serif', paddingLeft: '1.25rem' }
                                ]}
                            >
                                <li>Premium Maytronics One™ app control</li>
                                <li>Covers the Entire Pool - Floor, Walls, Waterline, Steps and Sun Ledge (20 cm)</li>
                                <li>6 Advanced Cleaning Modes: Full Coverage, Floor-Only, Waterline-Only, UltraRun™, SMART & Cove Mode</li>
                                <li>DebrisLock™ Backwash Filter with Ultra-Fine Particle Capture</li>
                                <li>SmartMap™ Navigation</li>
                                <li>3-year warranty</li>
                            </ul>

                            <button
                                css={[
                                    tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base py-3 px-10 rounded-2xl transition-colors duration-200 mt-4 mx-auto md:mx-0 self-start`,
                                    css`font-family: Flexo, system-ui, sans-serif !important; font-weight: 800; letter-spacing: 0.04em;`
                                ]}
                                onClick={() => window.open('https://mydolphin.co.za/product/dolphin-eon-120d-cordless-pool-cleaner/', '_blank')}
                            >
                                DISCOVER DOLPHIN EON™ 120D
                            </button>
                        </div>

                        {/* Grid Item 2 - EON 120D Image */}
                        <div css={[tw`hidden md:block`]} >
                            <div css={[tw`rounded-3xl overflow-hidden`]}>
                                <Img
                                    {...Eon120dProductTile.nodes[0]}
                                    loading="lazy"
                                    css={[tw`w-full`, `aspect-ratio: square;`]}
                                />
                            </div>
                        </div>

                        {/* Grid Item 3 */}
                        <div css={[tw`hidden md:block`]} >
                            <div css={[tw`rounded-3xl overflow-hidden`]}>
                                <Img
                                    {...Eon100ProductTile.nodes[0]}
                                    loading="lazy"
                                    css={[tw`w-full`, `aspect-ratio: square;`]}
                                />
                            </div>
                        </div>

                        {/* Grid Item 4 */}
                        <div
                            css={[
                                tw`bg-white rounded-lg items-start text-center md:text-left  `,
                            ]}
                        >
                            <div css={[tw`rounded-2xl overflow-hidden mb-6`]}>
                                <Img
                                    {...Eon100Logo.nodes[0]}
                                    loading="lazy"
                                    css={[tw`w-56 md:w-64 lg:w-80 mx-auto md:mx-0`]}
                                />
                            </div>
                            <p
                                css={[
                                    tw`text-base md:text-lg lg:text-xl md:italic font-bold  mb-3 text-[#58c7de]`,
                                    { fontFamily: 'Flexo, system-ui, sans-serif !important' }
                                ]}
                            >
                                Best for smart convenience
                            </p>

                            <ul
                                css={[
                                    tw`list-disc list-outside text-sm md:text-base lg:text-lg text-gray-700 text-left space-y-2 mx-auto md:mx-0`,
                                    { fontFamily: 'Flexo, system-ui, sans-serif', paddingLeft: '1.25rem' }
                                ]}
                            >
                                <li>Maytronics One™ app control</li>
                                <li>Covers the Entire Pool - Floor, Walls, Waterline, Steps and Sun Ledge (20 cm)</li>
                                <li>6 Advanced Cleaning Modes: Full Coverage, Floor Only, Waterline-Only, UltraRun™, SMART & Cove Mode</li>
                                <li>Monoblock Filtration</li>
                                <li>SmartMap™ Navigation</li>
                                <li>2-year warranty</li>
                            </ul>

                            <button
                                css={[
                                    tw`block bg-black hover:bg-gray-800 text-white text-sm md:text-base py-3 px-10 rounded-2xl transition-colors duration-200 mt-4 mx-auto md:mx-0 self-start`,
                                    css`font-family: Flexo, system-ui, sans-serif !important; font-weight: 800; letter-spacing: 0.04em;`
                                ]}
                                onClick={() => window.open('https://mydolphin.co.za/product/dolphin-eon-100-cordless-pool-cleaner/', '_blank')}
                            >
                                DISCOVER DOLPHIN EON™ 100
                            </button>
                        </div>
                    </div>
                </div>

                {/* Compare the EON Line section */}
                <div
                    css={[
                        tw`text-center px-4 pt-8 pb-2 md:pt-12 md:pb-3 lg:pt-16 lg:pb-4 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    <div css={[tw`w-full overflow-x-auto`]}>
                        <table
                            css={[tw`w-full min-w-[700px] divide-y divide-x divide-white`]}
                        >
                            <tr>
                                <td> </td>
                                <td css={[tw`py-4 px-2`]}>
                                    <Img
                                        {...Eon120TableImage.nodes[0]}
                                        loading="lazy"
                                        css={[tw`w-full`, `aspect-ratio: 675/400;`]}
                                    />
                                </td>
                                <td css={[tw`py-4 px-4`]}>
                                    <Img
                                        {...Eon100TableImage.nodes[0]}
                                        loading="lazy"
                                        css={[tw`w-full`, `aspect-ratio: 675/400;`]}
                                    />
                                </td>
                            </tr>

                            <tr css={[tw`divide-x divide-white`]}>
                                <th> </th>
                                <th css={[tw`text-black font-bold py-2`]}>
                                    Dolphin EON™ 100
                                </th>
                                <th css={[tw`text-black font-bold py-2`]}>
                                    Dolphin EON™ 120d
                                </th>
                            </tr>

                            {compareTableRowData.map((row, i) => {
                                return <CompareTableRow key={i} {...row} />
                            })}

                            <tr css={[tw``]}>
                                <td> </td>
                                <td css={[tw`py-4`]}>
                                    <button
                                        css={[
                                            tw`text-sm px-10 py-2 bg-blue-500 text-white rounded-full font-bold hover:text-blue-500 hover:bg-black transition-colors duration-200 shadow-lg`,
                                        ]}
                                        onClick={() => window.open('https://mydolphin.co.za/product/dolphin-eon-100-cordless-pool-cleaner/', '_blank')}
                                    >
                                        BUY NOW
                                    </button>
                                </td>

                                <td>
                                    <button
                                        css={[
                                            tw`text-sm px-10 py-2 bg-blue-500 text-white rounded-full font-bold hover:text-blue-500 hover:bg-black transition-colors duration-200 shadow-lg`,
                                        ]}
                                        onClick={() => window.open('https://mydolphin.co.za/product/dolphin-eon-120d-cordless-pool-cleaner/', '_blank')}
                                    >
                                        BUY NOW
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                {/* Gallery */}
                <div
                    css={[
                        tw`text-center px-4 pb-2 md:pb-3 lg:pb-4 mx-auto max-w-screen-lg w-full`,
                    ]}
                >
                    {/* Image section */}
                    <RoundedContainer css={[tw`text-center mt-6 mx-auto w-full h-[600px]`]}>
                        <Img
                            {...EonGalleryIso1.nodes[0]}
                            loading="lazy"
                            css={[
                                tw`h-full mx-auto`,

                                css`
									img {
										object-fit: cover !important;
									}
								`,
                            ]}
                        />
                    </RoundedContainer>

                    <section
                        css={[
                            tw`py-2 grid lg:grid-cols-12 gap-4 lg:py-4 mx-auto mt-4 w-full`,
                        ]}
                    >
                        <RoundedContainer
                            css={tw`
							object-cover w-full mx-auto items-center justify-center
							lg:col-span-7
							xl:col-span-7 h-[22rem] md:h-[28rem] shadow-xl`}
                        >
                            <Img
                                {...EonGalleryIso2.nodes[0]}
                                loading="lazy"
                                css={[
                                    tw`w-full h-full mx-auto rounded-3xl`,

                                    css`
										img {
											object-fit: cover !important;
											object-position: 40% 70% !important;
										}
									`,
                                ]}
                            />
                        </RoundedContainer>

                        <RoundedContainer
                            css={tw`
							object-cover w-full mx-auto items-center justify-center
							lg:col-span-5
							xl:col-span-5 h-[22rem] md:h-[28rem] shadow-xl`}
                        >
                            <Img
                                {...EonGalleryIso3.nodes[0]}
                                loading="lazy"
                                css={[
                                    tw`w-full h-full mx-auto rounded-3xl`,

                                    css`
										img {
											object-fit: cover !important;
											object-position: 40% 70% !important;
										}
									`,
                                ]}
                            />
                        </RoundedContainer>
                    </section>
                </div>

                {/* DolphinEonLogoTagline */}
                <div css={[tw`text-center px-4 pt-8 pb-8 md:pt-12 md:pb-12 lg:pt-16 lg:pb-16 mx-auto max-w-screen-lg`]}>

                    {/* Logo */}
                    <div css={[tw`flex justify-center mb-4`]}>
                        <Img
                            {...DolphinEonLogoTagline.nodes[0]}
                            loading="lazy"
                            css={[tw`w-64 md:w-80 lg:w-96 mx-auto`]}
                        />
                    </div>

                    {/* Buttons */}
                    <div css={[tw`flex justify-center gap-4`]}>
                        <button
                            css={[
                                tw`px-10 py-3 bg-black text-white font-black rounded-full hover:bg-gray-800 transition-colors duration-200`,
                                css`font-family: Flexo, system-ui, sans-serif !important; letter-spacing: 0.08em;`
                            ]}
                            onClick={() => navigate('/en-ZA/dolphin/eon-line')}
                        >
                            BUY NOW
                        </button>

                        <button
                            css={[
                                tw`px-10 py-3 bg-black text-white font-black rounded-full hover:bg-gray-800 transition-colors duration-200`,
                                css`font-family: Flexo, system-ui, sans-serif !important; letter-spacing: 0.08em;`
                            ]}
                            onClick={() => navigate('/en-ZA/support/find-a-dealer/')}
                        >
                            FIND A DEALER
                        </button>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

/**
 * Page content query
 * @private
 * @static
 * @returns {() => void}
 */
export const EonCordlessPoolCleanerZaPageQuery = graphql`
    query EonCordlessPoolCleanerZaPageQuery {
        EonHeroBannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6VBGLLa4n2Gd0OasDwIwxX" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				svg: file {
					url
					contentType
				}
				fluid(maxWidth: 2000, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        WhyChooseDolphinEON: allContentfulAsset(
			filter: {
				contentful_id: { eq: "13V8Ie1QuW2Q9KleaZumAC" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EON120dLogo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7KMTnBKptZ90iDk5eHrVbJ" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        Eon120dProductTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2dtt4XCElsrsjJ4K7DYmQ9" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        Eon100ProductTile: allContentfulAsset(
			filter: {
				contentful_id: { eq: "g3QTjsQxFQdAIN2WM1unM" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        Eon100Logo: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6IRZaulcr4gWZRa7nbEtKo" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonBannerTxt: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6V39xOtwnyTlBxgbmVc6tk" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        Eon120TableImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2ohCo8ELgyJoOHo4lhyRD0" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        Eon100TableImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "19EEUTRxCXrUsmA8ExNtbc" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonGalleryIso1: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2dv0IALfu4W9y3SjNKNtQt" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonGalleryIso2: allContentfulAsset(
			filter: {
				contentful_id: { eq: "xXsYg0pmHJIJtgPUaqicb" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonGalleryIso3: allContentfulAsset(
			filter: {
				contentful_id: { eq: "K9v1DLBrRM8MdEFVyd62t" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonFeatureTile1: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7G4GbW1xfGVXohciKcJ2kW" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonFeatureTile2: allContentfulAsset(
			filter: {
				contentful_id: { eq: "fC5hvXXcNDdnhQBOFoC8o" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonFeatureTile3: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6au7GNZ3PVBlIRUcmwmnry" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        EonFeatureTile4: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7MxneCoA9I4prK149WEl9d" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1080, maxHeight: 878, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}

        DolphinEonLogoTagline: allContentfulAsset(
			filter: {
				contentful_id: { eq: "NaBniIL4IUGg3jXIcFK82" }
				node_locale: { eq: "en-AU" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
	}
`

EonCordlessPoolCleaner.propTypes = {
    props: PropTypes.shape({
        data: PropTypes.shape({
            EonHeroBannerImage: PropTypes.object,
            WhyChooseDolphinEON: PropTypes.object,
            EON120dLogo: PropTypes.object,
            Eon120dProductTile: PropTypes.object,
            Eon100ProductTile: PropTypes.object,
            Eon100Logo: PropTypes.object,
            Eon120TableImage: PropTypes.object,
            Eon100TableImage: PropTypes.object,
            EonGalleryIso1: PropTypes.object,
            EonGalleryIso2: PropTypes.object,
            EonGalleryIso3: PropTypes.object,
            EonFeatureTile1: PropTypes.object,
            EonFeatureTile2: PropTypes.object,
            EonFeatureTile3: PropTypes.object,
            EonFeatureTile4: PropTypes.object,
            DolphinEonLogoTagline: PropTypes.object,
            EonBannerTxt: PropTypes.object
        }),
    }),
}
export default EonCordlessPoolCleaner
